import React, { useState, useContext } from "react";
import {
  Grid,
  Button,
  Card,
  CardContent,
  Typography,
  Divider,
  IconButton,
  TextField,
  Tooltip,
  InputBase,
  Switch,
  Paper,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { IoIosSettings, IoIosTrash } from "react-icons/io";
import { MdVisibility, MdVisibilityOff, MdContentCopy } from "react-icons/md";
import DialogOpen from "../Item/Dialog";
import { useSnackbar } from "notistack";
import { LangContext } from "../../Context/Langcontext";
import { APIContext } from "../../Context/APIContext";
import { createAPIkey, deleteAPIkey, updateAPIkey } from "../../API/apikey";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { makeStyles, withStyles } from "@material-ui/styles";
import { FaPlus } from "react-icons/fa";
import ChipInput from "material-ui-chip-input";

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 32,
    height: 20,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[200],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: "none",
  },
  track: {
    borderRadius: 22 / 2,
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
  },
  checked: {},
}))(Switch);

const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    minHeight: "-webkit-fill-available",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  textfield: {
    "& .MuiInputBase-input": {
      height: "1.5rem",
    },
  },
  inputStyle: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
  },
  inputdisStyle: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#b3b3b3",
  },
  inputLabelStyle: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
  },
  gridend: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
  },
  card: {
    width: "100%",
    boxShadow: "unset",
    backgroundColor: "#f1f1f1",
    borderRadius: 8,
    margin: "1rem 1rem 1rem 0rem",
    overflowX: "auto",
  },
  icon: {
    fontSize: "1.5rem",
  },
  nametext: {
    fontSize: "1.2rem",
    color: "#595A5A",
    fontWeight: 400,
  },
  disnametext: {
    color: "#b3b3b3",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
  value: {
    fontSize: "1rem",
    color: "#E16733",
    fontWeight: 400,
  },
  key: {
    fontSize: "1rem",
    color: "#595A5A",
    marginRight: "0.5rem",
    fontWeight: 200,
    whiteSpace: "nowrap",
  },
  diskey: {
    fontSize: "1rem",
    color: "#b3b3b3",
    marginRight: "0.5rem",
    fontWeight: 200,
    whiteSpace: "nowrap",
  },
  nodata: {
    width: "100%",
    height: "45vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    height: "calc(100vh - 17.9rem)",
  },
  cardstyle: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",
  },
  catddetail: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  copy: {
    width: "1.5rem",
    height: "auto",
    marginRight: "1rem",
    cursor: "pointer",
  },
  deltext: {
    fontWeight: 200,
    fontSize: "1rem",
    marginBottom: 10,
  },
  enabletext: {
    fontSize: "0.7rem",
    fontWeight: 200,
    marginBottom: "0.5rem",
  },
  fieldadd: {
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 14px",
    },
  },
  btnadd: {
    backgroundColor: "#92a8c4",
    padding: "16px 8px",
    "&:hover": {
      background: "#92a8c4",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  iconadd: {
    color: "#ffffff",
  },
  gridadd: {
    backgroundColor: "rgb(244 244 244)",
    marginTop: "1rem",
    borderRadius: 8,
  },
  formlabel: {
    "& .MuiTypography-body1": {
      fontWeight: 200,
    },
  },
  detailtext: {
    fontSize: "0.8rem",
    marginTop: "1rem",
    marginBottom: "1rem",
    fontWeight: 200,
  },
  chipadd: {
    "& .MuiInputBase-root": {
      paddingTop: 7,
      fontWeight: 200,
    },
  },
}));

const Generateapi = () => {
  const classes = useStyle();
  const [open, setOpen] = useState(false);
  const [del, setdel] = useState(false);
  const [update, setupdate] = useState(false);
  const [state, setstate] = useState({
    name: "",
    confirmname: "",
    create: true,
    delete: true,
  });
  const [check, setCheck] = useState({
    id: "",
    name: "",
    apikey: "",
    copy: false,
    enabled: false,
    update: true,
    type: 0,
    itemsHttp: [],
    itemsIp: [],
    http: "",
    ip: "",
  });
  const [value, setValue] = useState(0);
  const [items, setItems] = useState({ http: [], ip: [] });
  const [type, settype] = useState({ http: "", ip: "" });

  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const apiContext = useContext(APIContext);
  const data = apiContext.data;

  const handleChange = (event) => {
    setValue(Number(event.target.value));
    settype({ ...type, http: "", ip: "" });
    setItems({ ...items, http: [], ip: [] });
  };

  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState({
    status: false,
    name: "",
    statusconfirm: false,
    confirmname: "",
    http: false,
    namehttp: "",
    ip: false,
    nameip: "",
  });

  const genApi = async (e) => {
    e.preventDefault();
    let input = {
      app_name: state.name,
      enabled: true,
      restriction: {
        type: value,
      },
    };

    if (value !== 0) {
      if (value === 1) {
        input.restriction.items = items.http;
      } else if (value === 2) {
        input.restriction.items = items.ip;
      }
    }
    const create = await createAPIkey(input);
    setstate({ ...state, create: true });
    if (create.status.code === 201) {
      const apidata = [...data];
      create.data[0].show = true;
      apidata.push(create.data[0]);
      apiContext.setData(apidata);
      setOpen(false);
      setCheck({ ...check, update: true });
      enqueueSnackbar(lang.GenApiSuccess, {
        variant: "success",
      });

      setstate({ ...state, name: "", create: true });
      settype({ ...type, http: "", ip: "" });
      setValue(0);
      setItems({ ...items, http: [], ip: [] });
    } else {
      setstate({ ...state, name: "", create: true });
      if (data.length !== 0) {
        enqueueSnackbar(lang.CantCreateAPIkeymore, {
          variant: "error",
        });
      } else {
        enqueueSnackbar("มีบางอย่างผิดพลาด", {
          variant: "error",
        });
      }
    }
  };

  const delapi = async (e) => {
    e.preventDefault();
    if (state.confirmname !== check.name) {
      setError({ ...error, statusconfirm: true, confirmname: "Not matched" });
    } else {
      const delkey = await deleteAPIkey(check.id);
      setstate({ ...state, delete: true });
      if (delkey.status !== undefined) {
        enqueueSnackbar(lang.NoPermission, {
          variant: "error",
        });
      } else {
        setdel(false);
        let apidata = [...apiContext.data];
        let index = apidata
          .map((rs) => {
            return rs._id;
          })
          .indexOf(check.id);
        apidata.splice(index, 1);
        apiContext.setData(apidata);
        setstate({ ...state, name: "", confirmname: "", delete: true });
        enqueueSnackbar(lang.DeleteApiSuccess, {
          variant: "success",
        });
      }
    }
  };

  const updateapi = async (e) => {
    e.preventDefault();
    let input = {
      app_name: check.name,
      enabled: check.enabled,
      restriction: {
        type: check.type,
      },
    };

    if (check.type !== 0) {
      if (check.type === 1) {
        input.restriction.items = check.itemsHttp;
      } else if (check.type === 2) {
        input.restriction.items = check.itemsIp;
      }
    }

    const edit = await updateAPIkey(check.id, input);
    if (edit.status.code === 200) {
      let apidata = [...data];
      let index = apidata
        .map((rs) => {
          return rs._id;
        })
        .indexOf(check.id);
      edit.data[0].show = true;
      apidata[index] = edit.data[0];
      apiContext.setData(apidata);
      setupdate(false);
      enqueueSnackbar(lang.UpdateApiSuccess, {
        variant: "success",
      });
    } else {
      enqueueSnackbar(lang.NoPermission, {
        variant: "error",
      });
    }
  };

  const VisibleKey = (index) => {
    const key = [...data];
    key[index].show = !key[index].show;
    apiContext.setData(key);
  };

  const submitHttp = () => {
    // let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (type.http !== "") {
      let item = [...items.http];
      item.push(type.http);
      setItems({ ...items, http: item });
      settype({ ...type, http: "" });
      setError({ ...error, http: false, namehttp: "" });
      // if (regexp.test(type.http)) {
      //   if (type.http.startsWith("http")) {
      //     let item = [...items.http];
      //     item.push(type.http);
      //     setItems({ ...items, http: item });
      //     settype({ ...type, http: "" });
      //     setError({ ...error, http: false, namehttp: "" });
      //   } else {
      //     let item = [...items.http];
      //     item.push(`https://${type.http}`);
      //     setItems({ ...items, http: item });
      //     settype({ ...type, http: "" });
      //   }
      // } else {
      //   setError({ ...error, http: true, namehttp: "รูปแบบไม่ถูกต้อง" });
      // }
    } else {
      setError({ ...error, http: true, namehttp: "กรอกข้อมูลในช่องนี้" });
    }
  };

  const submitIp = () => {
    if (type.ip !== "") {
      let item = [...items.ip];
      item.push(type.ip);
      setItems({ ...items, ip: item });
      settype({ ...type, ip: "" });
      setError({ ...error, ip: false, nameip: "" });
    } else {
      setError({ ...error, ip: true, nameip: "กรอกข้อมูลในช่องนี้" });
    }
  };

  const updateHttp = () => {
    if (check.http !== "") {
      let item = [...check.itemsHttp];
      item.push(check.http);
      setCheck({ ...check, itemsHttp: item, http: "", update: false });
      setError({ ...error, http: false, namehttp: "" });
    } else {
      setError({ ...error, http: true, namehttp: "กรอกข้อมูลในช่องนี้" });
    }
  };

  const updateIp = () => {
    if (check.ip !== "") {
      let item = [...check.itemsIp];
      item.push(check.ip);
      setCheck({ ...check, itemsIp: item, ip: "", update: false });
      setError({ ...error, ip: false, nameip: "" });
    } else {
      setError({ ...error, ip: true, nameip: "กรอกข้อมูลในช่องนี้" });
    }
  };

  return (
    <div className={classes.root}>
      <Card className={data.length !== 0 ? classes.cardstyle : classes.cardapi}>
        <div style={{ margin: "2rem" }}>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.gridend}>
              <Tooltip title={lang.Generate} placement="top">
                <Button
                  className={classes.btnstyle}
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  {lang.Generate} API Key
                </Button>
              </Tooltip>
            </Grid>
            <Grid item xs={12}>
              {data.length !== 0 ? (
                data.map((res, index) => {
                  return (
                    <div key={res._id} style={{ marginTop: "1rem" }}>
                      <Typography
                        className={
                          res.enabled ? classes.nametext : classes.disnametext
                        }
                      >
                        {res.app_name}
                      </Typography>
                      <div style={{ width: "100%", display: "flex" }}>
                        <Card className={classes.card}>
                          <div className={classes.catddetail}>
                            <CardContent style={{ width: "100%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  className={
                                    res.enabled ? classes.key : classes.diskey
                                  }
                                >
                                  {lang.Key} :
                                </Typography>

                                <InputBase
                                  type={res.show ? "password" : "text"}
                                  value={res.api_key}
                                  disabled
                                  fullWidth
                                  style={{ minWidth: 100 }}
                                  inputProps={{
                                    className: res.enabled
                                      ? classes.inputStyle
                                      : classes.inputdisStyle,
                                  }}
                                />
                              </div>
                            </CardContent>
                            <span>
                              <IconButton
                                disabled={!res.enabled}
                                aria-label="Toggle password visibility"
                                onClick={() => {
                                  VisibleKey(index);
                                }}
                              >
                                {res.show ? (
                                  <MdVisibilityOff size={20} />
                                ) : (
                                  <MdVisibility size={20} />
                                )}
                              </IconButton>
                            </span>

                            <Tooltip
                              title={check.copy ? "Copied" : "Copy"}
                              placement="top"
                            >
                              <span>
                                <CopyToClipboard
                                  disabled={res.show || !res.enabled}
                                  text={res.api_key}
                                  onCopy={() => {
                                    setCheck({ ...check, copy: true });
                                    enqueueSnackbar(lang.APIcopied, {
                                      variant: "success",
                                    });
                                  }}
                                >
                                  <IconButton>
                                    <MdContentCopy size={20} />
                                  </IconButton>
                                </CopyToClipboard>
                              </span>
                            </Tooltip>
                          </div>
                        </Card>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <Tooltip title={lang.Edit} placement="top">
                              <IconButton
                                onClick={() => {
                                  setCheck({
                                    ...check,
                                    name: res.app_name,
                                    id: res._id,
                                    enabled: res.enabled,
                                    type:
                                      res.restriction !== undefined
                                        ? res.restriction.type
                                        : 0,
                                    itemsHttp:
                                      res.restriction !== undefined
                                        ? res.restriction.type === 1
                                          ? res.restriction.items
                                          : []
                                        : [],
                                    itemsIp:
                                      res.restriction !== undefined
                                        ? res.restriction.type === 2
                                          ? res.restriction.items
                                          : []
                                        : [],
                                  });
                                  setupdate(true);
                                }}
                              >
                                <IoIosSettings className={classes.icon} />
                              </IconButton>
                            </Tooltip>
                          </div>
                          <div>
                            <Tooltip title={lang.Delete} placement="top">
                              <span>
                                <IconButton
                                  onClick={() => {
                                    setCheck({
                                      ...check,
                                      name: res.app_name,
                                      id: res._id,
                                    });
                                    setdel(true);
                                  }}
                                >
                                  <IoIosTrash className={classes.icon} />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <Typography
                        style={{
                          marginBottom: "1rem",
                          fontSize: "1rem",
                          fontWeight: 200,
                          color: res.enabled ? "#595A5A" : "#b3b3b3",
                        }}
                      >
                        {res.updated_at === undefined
                          ? `${lang.CreateAt} ${
                              langContext.lang.locale === "th"
                                ? new Date(res.created_at).toLocaleString(undefined)
                                : new Date(res.created_at).toLocaleString(
                                  undefined
                                  )
                            }`
                          : `${lang.LastUpdate} ${
                              langContext.lang.locale === "th"
                                ? new Date(res.updated_at).toLocaleString(undefined)
                                : new Date(res.updated_at).toLocaleString(
                                  undefined
                                  )
                            }`}
                      </Typography>
                      <Divider />
                    </div>
                  );
                })
              ) : (
                <div className={classes.nodata}>
                  <Typography className={classes.key}>
                    {langContext.lang.locale === "th"
                      ? `ไม่มี ${lang.Key}`
                      : `No API ${lang.Key}`}
                  </Typography>
                  <Typography className={classes.key}>
                    {langContext.lang.locale === "th"
                      ? `โปรดสร้าง API Key`
                      : `Please create API Key`}
                  </Typography>
                </div>
              )}
            </Grid>
          </Grid>
          <DialogOpen
            type={"create"}
            open={open}
            genapi={genApi}
            handleClose={() => {
              setOpen(false);
            }}
            header={lang.Createkeyname}
            update={state.create}
          >
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              label={lang.Keyname}
              fullWidth
              value={state.name}
              onChange={(e) => {
                setstate({ ...state, name: e.target.value, create: false });
                setError({ ...error, status: false, name: "" });
              }}
              className={classes.textfield}
              inputProps={{
                className: classes.inputStyle,
              }}
              InputLabelProps={{
                className: classes.inputLabelStyle,
              }}
              error={error.status}
              helperText={error.name}
            />
            <Typography
              className={classes.nametext}
              style={{ marginTop: "1rem" }}
            >
              {lang.ApplicationRestriction}
            </Typography>
            <Typography className={classes.detailtext}>
              {lang.AppResDetail}
            </Typography>

            <Paper
              style={{
                boxShadow: "unset",
                backgroundColor: "rgb(244 244 244)",
              }}
            >
              <div style={{ margin: "0rem 1rem 1rem 1rem" }}>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="application"
                    name="application"
                    value={value}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label={lang.None}
                      className={classes.formlabel}
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label={`${lang.HTTPReferrers} (${lang.Website})`}
                      className={classes.formlabel}
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio color="primary" />}
                      label={`${
                        lang.IPaddress
                      } (${lang.Web.toLowerCase()}, ${lang.Server.toLowerCase()}, Cron jobs, ${
                        lang.etc
                      })`}
                      // "IP addresses ( web, server, Cron jobs, etc.)"
                      className={classes.formlabel}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Paper>

            {value === 0 ? null : value === 1 ? (
              <>
                <Typography
                  className={classes.nametext}
                  style={{ marginTop: "1rem" }}
                >
                  {lang.Websiterestrictions}
                </Typography>
                <Typography className={classes.detailtext}>
                  {lang.Restrictusage}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item lg={10} md={10} sm={10} xs={12}>
                    <ChipInput
                      fullWidth
                      variant="outlined"
                      placeholder="*example.com/*"
                      value={items.http}
                      className={classes.chipadd}
                      onUpdateInput={(e) => {
                        settype({ ...type, http: e.target.value });
                        setError({ ...error, http: false, namehttp: "" });
                      }}
                      onAdd={(chip) => {
                        let item = [...items.http];
                        item.push(chip);
                        setItems({ ...items, http: item });
                      }}
                      onDelete={(chip) => {
                        let item = items.http.filter((it) => {
                          return it !== chip;
                        });
                        setItems({ ...items, http: item });
                      }}
                      error={error.http}
                      helperText={error.namehttp}
                    />
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={12}>
                    <Button
                      fullWidth
                      className={classes.btnadd}
                      onClick={submitHttp}
                    >
                      <FaPlus className={classes.iconadd} />
                    </Button>
                  </Grid>
                </Grid>
              </>
            ) : value === 2 ? (
              <>
                <Typography
                  className={classes.nametext}
                  style={{ marginTop: "1rem" }}
                >
                  {lang.AcceptrequestIP}
                </Typography>
                <Typography className={classes.detailtext}>
                  {lang.SpecifiedIP}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item lg={10} md={10} sm={10} xs={12}>
                    <ChipInput
                      fullWidth
                      variant="outlined"
                      placeholder={`*${lang.IPaddress}*`}
                      value={items.ip}
                      className={classes.chipadd}
                      onUpdateInput={(e) => {
                        settype({ ...type, ip: e.target.value });
                        setError({ ...error, ip: false, nameip: "" });
                      }}
                      onAdd={(chip) => {
                        let item = [...items.ip];
                        item.push(chip);
                        setItems({ ...items, ip: item });
                      }}
                      onDelete={(chip) => {
                        let item = items.ip.filter((it) => {
                          return it !== chip;
                        });
                        setItems({ ...items, ip: item });
                      }}
                      error={error.ip}
                      helperText={error.nameip}
                    />
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={12}>
                    <Button
                      fullWidth
                      className={classes.btnadd}
                      onClick={submitIp}
                    >
                      <FaPlus className={classes.iconadd} />
                    </Button>
                  </Grid>
                </Grid>
              </>
            ) : null}
          </DialogOpen>

          <DialogOpen
            type={"update"}
            open={update}
            update={check.update}
            genapi={updateapi}
            handleClose={() => {
              setupdate(false);
            }}
            header={lang.Updatekey}
          >
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              label={lang.Keyname}
              fullWidth
              value={check.name}
              onChange={(e) => {
                const c = check.name;
                if (e.target.value === c) {
                  setCheck({ ...check, update: true, name: e.target.value });
                } else {
                  setCheck({ ...check, update: false, name: e.target.value });
                }
              }}
              className={classes.textfield}
              inputProps={{
                className: classes.inputStyle,
              }}
              InputLabelProps={{
                className: classes.inputLabelStyle,
              }}
            />
            <div style={{ marginTop: "1rem" }}>
              <Typography className={classes.enabletext}>
                {lang.EnableAPI}
              </Typography>
              <AntSwitch
                name="apikey"
                checked={check.enabled}
                onChange={() => {
                  setCheck({
                    ...check,
                    enabled: !check.enabled,
                    update: false,
                  });
                }}
              />
            </div>
            <Typography
              className={classes.nametext}
              style={{ marginTop: "1rem" }}
            >
              {lang.ApplicationRestriction}
            </Typography>
            <Typography className={classes.detailtext}>
              {lang.AppResDetail}
            </Typography>

            <Paper
              style={{
                boxShadow: "unset",
                backgroundColor: "rgb(244 244 244)",
              }}
            >
              <div style={{ margin: "0rem 1rem 1rem 1rem" }}>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="application"
                    name="application"
                    value={check.type}
                    onChange={(e) => {
                      setCheck({
                        ...check,
                        type: Number(e.target.value),
                        update: false,
                      });
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label={lang.None}
                      className={classes.formlabel}
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label={`${lang.HTTPReferrers} (${lang.Website})`}
                      className={classes.formlabel}
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio color="primary" />}
                      label={`${
                        lang.IPaddress
                      } (${lang.Web.toLowerCase()}, ${lang.Server.toLowerCase()}, Cron jobs, ${
                        lang.etc
                      })`}
                      className={classes.formlabel}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Paper>

            {check.type === 0 ? null : check.type === 1 ? (
              <>
                <Typography
                  className={classes.nametext}
                  style={{ marginTop: "1rem" }}
                >
                  {lang.Websiterestrictions}
                </Typography>
                <Typography className={classes.detailtext}>
                  {lang.Restrictusage}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item lg={10} md={10} sm={10} xs={12}>
                    <ChipInput
                      fullWidth
                      variant="outlined"
                      placeholder="*example.com/*"
                      value={check.itemsHttp}
                      className={classes.chipadd}
                      onUpdateInput={(e) => {
                        setCheck({ ...check, http: e.target.value });
                        setError({ ...error, http: false, namehttp: "" });
                      }}
                      onAdd={(chip) => {
                        let item = [...check.itemsHttp];
                        item.push(chip);
                        setCheck({ ...check, itemsHttp: item, update: false });
                      }}
                      onDelete={(chip) => {
                        let item = check.itemsHttp.filter((it) => {
                          return it !== chip;
                        });
                        setCheck({ ...check, itemsHttp: item, update: false });
                      }}
                      error={error.http}
                      helperText={error.namehttp}
                    />
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={12}>
                    <Button
                      fullWidth
                      className={classes.btnadd}
                      onClick={updateHttp}
                    >
                      <FaPlus className={classes.iconadd} />
                    </Button>
                  </Grid>
                </Grid>
              </>
            ) : check.type === 2 ? (
              <>
                <Typography
                  className={classes.nametext}
                  style={{ marginTop: "1rem" }}
                >
                  {lang.AcceptrequestIP}
                </Typography>
                <Typography className={classes.detailtext}>
                  {lang.SpecifiedIP}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item lg={10} md={10} sm={10} xs={12}>
                    <ChipInput
                      fullWidth
                      variant="outlined"
                      placeholder={`*${lang.IPaddress}*`}
                      value={check.itemsIp}
                      className={classes.chipadd}
                      onUpdateInput={(e) => {
                        setCheck({ ...check, ip: e.target.value });
                        setError({ ...error, ip: false, nameip: "" });
                      }}
                      onAdd={(chip) => {
                        let item = [...check.itemsIp];
                        item.push(chip);
                        setCheck({ ...check, itemsIp: item, update: false });
                      }}
                      onDelete={(chip) => {
                        let item = check.itemsIp.filter((it) => {
                          return it !== chip;
                        });
                        setCheck({ ...check, itemsIp: item, update: false });
                      }}
                      error={error.ip}
                      helperText={error.nameip}
                    />
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={12}>
                    <Button
                      fullWidth
                      className={classes.btnadd}
                      onClick={updateIp}
                    >
                      <FaPlus className={classes.iconadd} />
                    </Button>
                  </Grid>
                </Grid>
              </>
            ) : null}
          </DialogOpen>

          <DialogOpen
            type={"delete"}
            open={del}
            genapi={delapi}
            handleClose={() => {
              setdel(false);
            }}
            header={`${lang.Deletekey} ?`}
            update={state.delete}
          >
            <Typography className={classes.deltext}>
              {lang.Confirmkeydelete}
            </Typography>
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              label="Key name"
              fullWidth
              value={state.confirmname}
              onChange={(e) => {
                setstate({
                  ...state,
                  confirmname: e.target.value,
                  delete: false,
                });
                setError({ ...error, statusconfirm: false, confirmname: "" });
              }}
              className={classes.textfield}
              inputProps={{
                className: classes.inputStyle,
              }}
              InputLabelProps={{
                className: classes.inputLabelStyle,
              }}
              error={error.statusconfirm}
              helperText={error.confirmname}
            />
          </DialogOpen>
        </div>
      </Card>
    </div>
  );
};

export default Generateapi;
